// src/subscreens/seller/settings/SettingsCards.js
import { useNavigate } from "react-router-dom";

const SettingsCards = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="st-card">
        <h4 className="st-card-title">Store Details</h4>
        <p className="st-muted">Update store name, logo, and description.</p>
        <button className="st-btn" onClick={() => navigate("/seller/editstore")}>
          Edit Store
        </button>
      </div>

      <div className="st-card">
        <h4 className="st-card-title">Terms & Conditions</h4>
        <p className="st-muted">Review the terms you agreed to at signup.</p>
        <button className="st-btn" onClick={() => navigate("/seller/terms")}>
          View Terms & Conditions
        </button>
      </div>
    </>
  );
};

export default SettingsCards;